<!-- Search Bids Filters -->
<div class="card">
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <div class="d-flex align-items-center my-1">
        <i class="ki-duotone ki-magnifier fs-2 me-3">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <h3 class="fw-bold m-0">Search Auction Bids</h3>
      </div>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-user-table-toolbar="base">
        <button type="button"
                class="btn btn-success btn-sm me-3"
                (click)="saveSearch()"
                [disabled]="!isSaveSearchEnabled">
          <i class="ki-duotone ki-save-2 fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Save Search
        </button>
        <button type="button" class="btn btn-dark btn-sm fw-bold d-flex me-3" (click)="applyMainFilters()">
          <i class="ki-duotone ki-magnifier fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Search
        </button>
        <button type="button" class="btn btn-light btn-sm" (click)="clearFilters()">
          <i class="ki-duotone ki-cross fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Clear All
        </button>
      </div>
    </div>
  </div>

  <div class="card-body py-4">
    <div class="row g-6">
      <!-- Date Filter -->
      <div class="col-lg-2 col-md-4 col-sm-6">
        <div class="filter-section">
          <h6 class="fw-bold text-gray-800 mb-3">Date</h6>
          <div class="filter-options">
            <!-- All Checkbox -->
            <div class="form-check form-check-custom form-check-solid mb-3 pb-2 border-bottom">
              <input class="form-check-input"
                     type="checkbox"
                     id="date_all"
                     [checked]="isAllDatesChecked()"
                     (change)="onDateAllChange($any($event.target).checked)">
              <label class="form-check-label fw-bold text-gray-800"
                     for="date_all">
                All
              </label>
            </div>
            <!-- Individual Date Checkboxes -->
            <div class="form-check form-check-custom form-check-solid mb-2"
                 *ngFor="let date of dateOptions">
              <input class="form-check-input"
                     type="checkbox"
                     [id]="'date_' + date.value"
                     [checked]="date.checked"
                     (change)="onFilterChange('dates', date.value, $any($event.target).checked)">
              <label class="form-check-label fw-semibold text-gray-700"
                     [for]="'date_' + date.value">
                {{ date.label }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Auction Filter -->
      <div class="col-lg-2 col-md-4 col-sm-6">
        <div class="filter-section">
          <h6 class="fw-bold text-gray-800 mb-3">Auction</h6>
          <div class="filter-options">
            <!-- All Checkbox -->
            <div class="form-check form-check-custom form-check-solid mb-3 pb-2 border-bottom">
              <input class="form-check-input"
                     type="checkbox"
                     id="auction_all"
                     [checked]="isAllAuctionsChecked()"
                     (change)="onAuctionAllChange($any($event.target).checked)">
              <label class="form-check-label fw-bold text-gray-800"
                     for="auction_all">
                All
              </label>
            </div>
            <!-- Individual Auction Checkboxes -->
            <div class="form-check form-check-custom form-check-solid mb-2"
                 *ngFor="let auction of auctionOptions">
              <input class="form-check-input"
                     type="checkbox"
                     [id]="'auction_' + auction.value"
                     [checked]="auction.checked"
                     (change)="onFilterChange('auctions', auction.value, $any($event.target).checked)">
              <label class="form-check-label fw-semibold text-gray-700"
                     [for]="'auction_' + auction.value">
                {{ auction.label }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Make Filter -->
      <div class="col-lg-2 col-md-4 col-sm-6">
        <div class="filter-section">
          <h6 class="fw-bold text-gray-800 mb-3">Make</h6>
          <div class="filter-options">
            <div *ngIf="isLoadingMakes" class="text-center py-2">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span class="ms-2 small">Loading...</span>
            </div>
            <!-- All Checkbox -->
            <div *ngIf="!isLoadingMakes && makeOptions.length > 0" class="form-check form-check-custom form-check-solid mb-3 pb-2 border-bottom">
              <input class="form-check-input"
                     type="checkbox"
                     id="make_all"
                     [checked]="isAllMakesChecked()"
                     (change)="onMakeAllChange($any($event.target).checked)">
              <label class="form-check-label fw-bold text-gray-800"
                     for="make_all">
                All
              </label>
            </div>
            <!-- Individual Make Checkboxes -->
            <div class="form-check form-check-custom form-check-solid mb-2"
                 *ngFor="let make of makeOptions">
              <input class="form-check-input"
                     type="checkbox"
                     [id]="'make_' + make.value"
                     [checked]="make.checked"
                     (change)="onFilterChange('makes', make.value, $any($event.target).checked)">
              <label class="form-check-label fw-semibold text-gray-700"
                     [for]="'make_' + make.value">
                <span [innerHTML]="formatLabelWithCount(make.label)"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Model Filter -->
      <div class="col-lg-2 col-md-4 col-sm-6">
        <div class="filter-section">
          <h6 class="fw-bold text-gray-800 mb-3">Model</h6>
          <div class="filter-options">
            <div *ngIf="isLoadingModels" class="text-center py-2">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span class="ms-2 small">Loading...</span>
            </div>
            <div *ngIf="!isLoadingModels && modelOptions.length === 0 && filters.makes.length > 0"
                 class="text-muted py-2 small">
              No models found
            </div>
            <div *ngIf="!isLoadingModels && filters.makes.length === 0"
                 class="text-muted py-2 small">
              Select make first
            </div>
            <!-- All Checkbox -->
            <div *ngIf="!isLoadingModels && modelOptions.length > 0" class="form-check form-check-custom form-check-solid mb-3 pb-2 border-bottom">
              <input class="form-check-input"
                     type="checkbox"
                     id="model_all"
                     [checked]="isAllModelsChecked()"
                     (change)="onModelAllChange($any($event.target).checked)">
              <label class="form-check-label fw-bold text-gray-800"
                     for="model_all">
                All
              </label>
            </div>
            <!-- Individual Model Checkboxes -->
            <div class="form-check form-check-custom form-check-solid mb-2"
                 *ngFor="let model of modelOptions">
              <input class="form-check-input"
                     type="checkbox"
                     [id]="'model_' + model.value"
                     [checked]="model.checked"
                     (change)="onFilterChange('models', model.value, $any($event.target).checked)">
              <label class="form-check-label fw-semibold text-gray-700"
                     [for]="'model_' + model.value">
                <span [innerHTML]="formatLabelWithCount(model.label)"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- More Filters -->
      <div class="col-lg-2 col-md-4 col-sm-6">
        <div class="filter-section">
          <h6 class="fw-bold text-gray-800 mb-3">More Filters</h6>
          <div class="filter-options">
            <!-- Year From -->
            <div class="mb-2">
              <label class="form-label small fw-semibold text-gray-700">Year From</label>
              <select class="form-select form-select-sm"
                      [(ngModel)]="filters.yearFrom"
                      (change)="onDropdownChange('yearFrom', $any($event.target).value)">
                <option value="">Select Year</option>
                <option *ngFor="let year of yearOptions" [value]="year.value">{{ year.label }}</option>
              </select>
            </div>

            <!-- Year To -->
            <div class="mb-2">
              <label class="form-label small fw-semibold text-gray-700">Year To</label>
              <select class="form-select form-select-sm"
                      [(ngModel)]="filters.yearTo"
                      (change)="onDropdownChange('yearTo', $any($event.target).value)">
                <option value="">Select Year</option>
                <option *ngFor="let year of yearOptions" [value]="year.value">{{ year.label }}</option>
              </select>
            </div>

            <!-- Mileage From -->
            <div class="mb-2">
              <label class="form-label small fw-semibold text-gray-700">Mileage From (km)</label>
              <input type="text"
                     class="form-control form-control-sm"
                     [(ngModel)]="filters.mileageFrom"
                     (input)="onMileageInput('mileageFrom', $any($event.target).value)"
                     placeholder="Enter mileage"
                     pattern="[0-9]*"
                     inputmode="numeric">
            </div>

            <!-- Mileage To -->
            <div class="mb-2">
              <label class="form-label small fw-semibold text-gray-700">Mileage To (km)</label>
              <input type="text"
                     class="form-control form-control-sm"
                     [(ngModel)]="filters.mileageTo"
                     (input)="onMileageInput('mileageTo', $any($event.target).value)"
                     placeholder="Enter mileage"
                     pattern="[0-9]*"
                     inputmode="numeric">
            </div>

            <!-- Transmission -->
            <div class="mb-2">
              <label class="form-label small fw-semibold text-gray-700">Transmission</label>
              <select class="form-select form-select-sm"
                      [(ngModel)]="filters.transmission"
                      (change)="onDropdownChange('transmission', $any($event.target).value)">
                <option value="">Select Transmission</option>
                <option *ngFor="let trans of transmissionOptions" [value]="trans.value">{{ trans.label }}</option>
              </select>
            </div>

            <!-- Color -->
            <div class="mb-2">
              <label class="form-label small fw-semibold text-gray-700">Color</label>
              <select class="form-select form-select-sm"
                      [(ngModel)]="filters.color"
                      (change)="onDropdownChange('color', $any($event.target).value)">
                <option value="">Select Color</option>
                <option *ngFor="let color of colorOptions" [value]="color.value">{{ color.label }}</option>
              </select>
            </div>

            <!-- Displacement -->
            <div class="mb-2">
              <label class="form-label small fw-semibold text-gray-700">Displacement</label>
              <select class="form-select form-select-sm"
                      [(ngModel)]="filters.displacement"
                      (change)="onDropdownChange('displacement', $any($event.target).value)">
                <option value="">Select Displacement</option>
                <option *ngFor="let disp of displacementOptions" [value]="disp.value">{{ disp.label }}</option>
              </select>
            </div>

            <!-- Grade -->
            <div class="mb-2">
              <label class="form-label small fw-semibold text-gray-700">Grade</label>
              <select class="form-select form-select-sm"
                      [(ngModel)]="filters.grade"
                      (change)="onDropdownChange('grade', $any($event.target).value)">
                <option value="">Select Grade</option>
                <option *ngFor="let grade of gradeOptions" [value]="grade.value">{{ grade.label }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- Chassis Model Filter -->
      <div class="col-lg-2 col-md-4 col-sm-6">
        <div class="filter-section">
          <h6 class="fw-bold text-gray-800 mb-3">Chassis Model</h6>
          <div class="filter-options">
            <div *ngIf="isLoadingChassisModels" class="text-center py-2">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span class="ms-2 small">Loading...</span>
            </div>
            <div *ngIf="!isLoadingChassisModels && chassisModelOptions.length === 0 && filters.models.length > 0"
                 class="text-muted py-2 small">
              No chassis models found
            </div>
            <div *ngIf="!isLoadingChassisModels && filters.models.length === 0"
                 class="text-muted py-2 small">
              Select model first
            </div>
            <!-- All Checkbox -->
            <div *ngIf="!isLoadingChassisModels && chassisModelOptions.length > 0" class="form-check form-check-custom form-check-solid mb-3 pb-2 border-bottom">
              <input class="form-check-input"
                     type="checkbox"
                     id="chassis_all"
                     [checked]="isAllChassisModelsChecked()"
                     (change)="onChassisModelAllChange($any($event.target).checked)">
              <label class="form-check-label fw-bold text-gray-800"
                     for="chassis_all">
                All
              </label>
            </div>
            <!-- Individual Chassis Model Checkboxes -->
            <div class="form-check form-check-custom form-check-solid mb-2"
                 *ngFor="let chassis of chassisModelOptions">
              <input class="form-check-input"
                     type="checkbox"
                     [id]="'chassis_' + chassis.value"
                     [checked]="chassis.checked"
                     (change)="onFilterChange('chassisModels', chassis.value, $any($event.target).checked)">
              <label class="form-check-label fw-semibold text-gray-700"
                     [for]="'chassis_' + chassis.value">
                <span [innerHTML]="formatLabelWithCount(chassis.label)"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- OR Separator -->
    <div class="row mt-4 mb-4">
      <div class="col-12">
        <div class="d-flex align-items-center">
          <hr class="flex-grow-1">
          <span class="px-3 text-muted fw-bold fs-5">OR</span>
          <hr class="flex-grow-1">
        </div>
      </div>
    </div>

    <!-- Lot Number Search Section -->
    <div class="row g-6">
      <!-- Search by Lot Number -->
      <div class="col-lg-4 col-md-6 mx-auto">
        <div class="filter-section">
          <h6 class="fw-bold text-gray-800 mb-3">SEARCH BY LOT NUMBER</h6>
          <div class="d-flex flex-column">
            <!-- Lot Number Input -->
            <div class="mb-2">
              <input type="text"
                     class="form-control form-control-sm"
                     placeholder="Lot Number or Chassis Model"
                     [(ngModel)]="filters.lotNumber"
                     (input)="onLotNumberChange($any($event.target).value)">
            </div>

            <!-- Auction Dropdown -->
            <div class="mb-3">
              <select class="form-select form-select-sm"
                      [(ngModel)]="filters.lotSearchAuction"
                      (change)="onDropdownChange('lotSearchAuction', $any($event.target).value)">
                <option value="">-- Select Auction --</option>
                <option *ngFor="let auction of auctionOptions" [value]="auction.value">{{ auction.label }}</option>
              </select>
            </div>

            <!-- Search Button -->
            <div class="mb-3">
              <button type="button" class="btn btn-primary btn-sm w-100" (click)="searchByLotNumber()">
                Search
              </button>
            </div>

            <!-- Info Text -->
            <div class="text-muted small text-center">
              <p class="mb-1">Comma Separate to Search Multiple</p>
              <p class="mb-0">Lot No. For eg. 4001, 4002...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Auction Cars Listing -->
<div class="card mt-6" *ngIf="cars.length > 0 || isLoadingCars">
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <div class="d-flex align-items-center">
        <h3 class="fw-bold m-0">Auction Results</h3>
        <span class="badge badge-light-primary ms-3" *ngIf="paginationInfo.total > 0">
          {{ paginationInfo.total }} Cars Found
        </span>
      </div>
    </div>
  </div>

  <div class="card-body py-4">
    <!-- Loading State -->
    <div *ngIf="isLoadingCars" class="text-center py-10">
      <div class="d-flex align-items-center justify-content-center">
        <div class="spinner-border spinner-border-lg text-primary me-3"></div>
        <span class="text-muted fs-4">Loading auction cars...</span>
      </div>
    </div>

    <!-- Cars Table -->
    <div *ngIf="!isLoadingCars && cars.length > 0" class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="min-w-80px">Image</th>
            <th class="min-w-100px">Auction Hall</th>
            <th class="min-w-120px">Lot No</th>
            <th class="min-w-150px">Vehicle Details</th>
            <th class="min-w-100px">Year</th>
            <th class="min-w-100px">Mileage</th>
            <th class="min-w-100px">Fuel</th>
            <th class="min-w-100px">Color</th>
            <th class="min-w-100px">Price</th>
            <th class="min-w-120px">Auction Date</th>
            <th class="min-w-100px">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let car of cars; trackBy: trackByFn"
              class="clickable-row"
              (click)="onRowClick(car)"
              role="button"
              tabindex="0"
              (keydown.enter)="onRowClick(car)"
              (keydown.space)="onRowClick(car)">
            <!-- Car Image -->
            <td>
              <div class="symbol symbol-60px">
                <img [src]="getMainImage(car)"
                     [alt]="car.name + ' Image'"
                     class="rounded"
                     (error)="$any($event.target).src='assets/media/stock/600x400/img-1.jpg'">
              </div>
            </td>

            <!-- Auction Hall -->
            <td>
              <span class="text-dark">{{ car.hall_name || 'N/A' }}</span>
            </td>

            <!-- Lot Number -->
            <td>
              <div class="d-flex flex-column">
                <span class="fw-bold text-primary fs-6">{{ car.lot_no }}</span>
                <small class="text-muted">{{ car.inventory_no }}</small>
              </div>
            </td>

            <!-- Vehicle Details -->
            <td>
              <div class="d-flex flex-column">
                <span class="fw-bold text-dark fs-6 mb-1">{{ car.name }}</span>
                <small class="text-muted mb-1">{{ car.company_name }}</small>
                <small class="text-muted mb-2">{{ car.engine_capacity }}cc</small>
                <div class="d-flex gap-1">
                  <!-- <button
                    type="button"
                    class="btn btn-success btn-sm px-2 py-1"
                    (click)="onSaveVehicle($event, car)"
                    title="Save Vehicle">
                    <i class="ki-duotone ki-check fs-4">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                    Save
                  </button> -->
                  <button
                    type="button"
                    class="btn btn-primary btn-sm px-2 py-1"
                    (click)="onMakeBid($event, car)"
                    title="Make Bid">
                    <i class="ki-duotone ki-dollar fs-4">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                    </i>
                    Bid
                  </button>
                </div>
              </div>
            </td>

            <!-- Year -->
            <td>
              <span class="fw-semibold text-dark">{{ car.year }}</span>
            </td>

            <!-- Mileage -->
            <td>
              <span class="text-dark">{{ formatMileage(car.mileage) }}</span>
            </td>

            <!-- Fuel Type -->
            <td>
              <span class="badge badge-light-info">{{ car.fuel_type }}</span>
            </td>

            <!-- Color -->
            <td>
              <span class="text-dark">{{ car.color }}</span>
            </td>

            <!-- Price -->
            <td>
              <span class="fw-bold text-success fs-6">{{ formatPrice(car.price) }}</span>
            </td>

            <!-- Auction Date -->
            <td>
              <div class="d-flex flex-column">
                <span class="text-dark">{{ formatAuctionDate(car.auction_date) }}</span>
                <!-- <small class="text-muted">{{ car.type | uppercase }}</small> -->
              </div>
            </td>

            <!-- Status -->
            <td>
              <span class="badge"
                    [class.badge-light-success]="!car.is_sold"
                    [class.badge-light-danger]="car.is_sold">
                {{ car.is_sold ? 'Sold' : 'Available' }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- No Results -->
    <div *ngIf="!isLoadingCars && cars.length === 0" class="text-center py-10">
      <div class="d-flex flex-column align-items-center">
        <i class="ki-duotone ki-search-list fs-3x text-muted mb-4">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
        </i>
        <h3 class="text-muted">No auction cars found</h3>
        <p class="text-muted">Try adjusting your search filters or lot numbers</p>
      </div>
    </div>

    <!-- Pagination -->
    <app-pagination
      *ngIf="!isLoadingCars && cars.length > 0"
      [paginationInfo]="paginationInfo"
      [loading]="isLoadingCars"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>

<!-- Add Saved Search Modal -->
<app-add-saved-search (searchSaved)="onSearchSaved()"></app-add-saved-search>
